module.exports = __webpack_public_path__ + "static/media/login.078723d2.jpg";